'use strict';

export default function($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/jdOrder", "/jdOrder/list");

  $stateProvider
    .state('jdOrder', {
      url: '/jdOrder',
      template: require('./jdOrder.html'),
      authenticate: true
    })
    .state('jdOrder.list', {
      url: '/list?page',
      template: require('./list/list.html'),
      controller: 'JdOrderListController',
      controllerAs: 'jdOrderListCtrl',
      authenticate: true
    })
    .state('jdOrder.show', {
      url: '/show/:id',
      template: require('./show/show.html'),
      controller: 'JdOrderShowController',
      controllerAs: 'jdOrderShowCtrl',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/jdOrder/jdOrder.routes.js